import { OtpValidateAdapter } from '../../../adapter';

export default async function OtpValidateUseCase(event) {
    // const { loanAccountNumber, type, otp } = event;
    const { loanAccountNumber, mobileNo, email, type, otp } = event;

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionrenewal.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/v1/otp/hcr-validate'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/v1/otp/hcr-validate'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/otp/hcr-validate`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/otp/hcr-validate`;

    // prepare data
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/v1/otp/validate';

    let payload;

    if(Object.keys(event).length == 2 || loanAccountNumber) {
        payload = { coicNo: !!loanAccountNumber ? loanAccountNumber : undefined, type: type ?? 'email', otp: !!otp ? otp : undefined  }
    }

    // handle request
    const result = await OtpValidateAdapter(endpoint, JSON.stringify(payload));
    console.log("payload", result);
    return result;
}
